import { useEffect, useRef, useState } from 'react';

/**
 * Hook to detect when the app is launched (not just resumed from background)
 * Uses a simple approach: track if this is the initial load or a subsequent navigation
 */
export const useAppLaunchDetection = () => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isRestoring, setIsRestoring] = useState(false);
  const [isInitialRedirect, setIsInitialRedirect] = useState(true);
  const hasNavigatedRef = useRef(false);

  useEffect(() => {
    // After the first render, mark that we're no longer in initial load
    const timer = setTimeout(() => {
      setIsInitialLoad(false);
      // Also end the initial redirect phase after a bit longer to allow for router redirects
      setTimeout(() => {
        setIsInitialRedirect(false);
      }, 100); // Reduced from 500ms to 100ms
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Reset the initial load state after it's been consumed
  const resetInitialLoad = () => {
    setIsInitialLoad(false);
    hasNavigatedRef.current = true;
  };

  // Start restoration process
  const startRestoration = () => {
    setIsRestoring(true);
  };

  // End restoration process
  const endRestoration = () => {
    setIsRestoring(false);
  };

  return {
    isInitialLoad,
    isRestoring,
    isInitialRedirect,
    resetInitialLoad,
    startRestoration,
    endRestoration,
    hasNavigated: hasNavigatedRef.current,
  };
};
